import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { updateTeamPage, updateTeamPhoto, updateTeam, } from '../../../helpers/requests/fundraising-pages';
import {
  useTeamCaptainSurveyResponses,
  useTeamInfo,
  useTeamPageInfo,
  useTeamPhoto,
  useTeamRoster,
  useTeamMemberPhotos,
  useSurveyResponses,
  useBackgroundImageHeroes,
  useEventInfo,
} from '../../../hooks';
import ProgressBar from '../../../components/progress-bar';
import PageTitle from '../../../components/page-title';
import TopHeroesList from '../../../components/top-heroes-list';
import TopList from '../../../components/top-list';
import ProfileImage from '../../../components/profile-image';
import SocialShare from '../../../components/social-share';
import { convertCentsToDollars } from '../../../helpers/base';
import EventDetailsRow from '../../../components/event-details-row';

import MobileSocialShareModal from '../../../components/mobile-social-share-modal';
import EditGoalModal from '../../../components/edit-goal-modal';
import EditImageModal from '../../../components/edit-image-modal';
import EditRichTextModal from '../../../components/edit-rich-text-modal';
import EditTitleModal from '../../../components/edit-title-modal';
import LinkListModal from '../../../components/link-list-modal';
import { EVENT_TYPE } from '../../../constants/dom-events';
import ReactHtmlParser from 'react-html-parser';
import EditBackgroundImageModal from '../../../components/edit-background-image-modal';
import { updateSurveyResponses, updateSurveyResponsesForBackgrounds } from '../../../services/luminate';
import SearchParticipant from '../../../components/search-participant';
import EditEventDetailsModal from '../../../components/edit-event-details-modal';

/** Page Constants */
const EVENT_ID = luminateProperties.teamPage.frId;
const EVENT_NAME= luminateProperties.eventName;
const EVENT_LINK= `${luminateProperties.secure}TR?fr_id=${EVENT_ID}&pg=entry`;
const TEAM_ID = luminateProperties.teamPage.teamId;
const EVENT_TYPE_SEARCH = 'heroes';

/** Event FRID Numbers */
const CHICAGO = process.env.HEROES_CHICAGO_FRIDS;
const NEWYORK = process.env.HEROES_NEWYORK_FRIDS;
const LONDON = process.env.HEROES_LONDON_FRIDS;
const BOSTON = process.env.HEROES_BOSTON_FRIDS;
const BERLIN = process.env.HEROES_BERLIN_FRIDS;

let DEFAULT_BG_IMAGE;

const checkFrID = (city) => {
  if (city.includes(luminateProperties.frId)){
    // console.log("yes found it");
    return luminateProperties.frId
  }
}

/** BOUNDLESS API */
const BOUNDLESS_MOTION_DB = process.env.HEROES_BOUNDLESS_MOTION_DB;
const BOUNDLESS_USER = process.env.HEROES_BOUNDLESS_MOTION_USER;
const BOUNDLESS_PASS = process.env.HEROES_BOUNDLESS_MOTION_PASS;
const BOUNDLESS_MOTION_PREFIX = process.env.HEROES_BOUNDLESS_MOTION_PREFIX;
const username = BOUNDLESS_USER;
const password = BOUNDLESS_PASS;

let headers = new Headers();
headers.set('Authorization', 'Basic ' + Buffer.from(username + ":" + password).toString('base64'));

document.addEventListener(EVENT_TYPE.DOM_LOAD, () => {
  const $layout = document.querySelector('#appRoot');
  ReactDOM.render(<TeamPage />, $layout);
});

export const getBoundlessTeamMemberData = async (eventId, consId) => {
  const url = `https://${BOUNDLESS_MOTION_PREFIX}.boundlessfundraising.com/mobiles/${BOUNDLESS_MOTION_DB}/getMotionActivitySummary?activity_scope=user&event_id=${eventId}&user_id=${consId}`;
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json())
  .then(
    (result) => {
      return result;
    },
    (error) => {
      setIsLoaded(true);
      setError(error);
    }
  )
};

const TeamPage = () => {
  const teamInfo = useTeamInfo(TEAM_ID);
  const teamPageInfo = useTeamPageInfo(EVENT_ID, TEAM_ID);
  const teamPhoto = useTeamPhoto(EVENT_ID, teamInfo.data.captainConsId);
  const teamRoster = useTeamRoster(EVENT_ID, TEAM_ID);
  const surveyResponses = useTeamCaptainSurveyResponses(EVENT_ID, teamInfo.data.captainConsId);
  const surveyResponsesForEventDetailsUpdate = useSurveyResponses(EVENT_ID, teamInfo.data.captainConsId);
  const teamMemberPhotos = useTeamMemberPhotos(EVENT_ID, teamRoster.data);
  const surveyResponsesForBgImage = useSurveyResponses(EVENT_ID, teamInfo.data.captainConsId);
  const bgImageData = useBackgroundImageHeroes(EVENT_ID);
  const teamNameSearch = encodeURIComponent(teamInfo.data.name);
  const viewAllUrl = `${luminateProperties.secure}SPageServer?pagename=${EVENT_TYPE_SEARCH}_search&eventId=${EVENT_ID}&searchType=participant&filter=all&teamName=${teamNameSearch}`;
  const joinTeamUrl = `${luminateProperties.secure}TRR/Heroes/Heroes?fr_tjoin=${TEAM_ID}&pg=tfind&fr_id=${EVENT_ID}&s_teamStatus=Team%20Runner`;

  const IS_TEAM_CAPTAIN = luminateProperties.user.consId && parseInt(luminateProperties.user.consId) === parseInt(teamInfo.data.captainConsId);
  const TEAM_CAPTAIN_LINK = `${luminateProperties.secure}TR?pg=personal&fr_id=${EVENT_ID}&px=${teamInfo.data.captainConsId}`;

  const eventInfo = useEventInfo(EVENT_NAME, 'Heroes', '');

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [editGoalModalIsOpen, setEditGoalModalIsOpen] = useState(false);
  const [editTitleModalIsOpen, setEditTitleModalIsOpen] = useState(false);
  const [editPhotoModalIsOpen, setEditPhotoModalIsOpen] = useState(false);
  const [editBackgroundPhotoModalIsOpen, setEditBackgroundPhotoModalIsOpen] = useState(false);
  const [editRichTextModalIsOpen, setEditRichTextModalIsOpen] = useState(false);
  const [editEventModalIsOpen, setEditEventModalIsOpen] = useState(false);
  const [supportTeamModalIsOpen, setSupportTeamModalIsOpen] = useState(false);
  const [mobileSocialShareModalIsOpen, setMobileSocialShareModalIsOpen] = useState(false);
  const [selectedBackgroundImage, setSelectedBackgroundImage] = useState(DEFAULT_BG_IMAGE);

  /** value initializations */
  //let hasEventDetails = false;

  const closeModals = () => {
    setEditGoalModalIsOpen(false);
    setEditTitleModalIsOpen(false);
    setEditPhotoModalIsOpen(false);
    setEditBackgroundPhotoModalIsOpen(false);
    setEditRichTextModalIsOpen(false);
    setSupportTeamModalIsOpen(false);
    setMobileSocialShareModalIsOpen(false);
    setErrorMessage(null);
  };

  /* const renderHeroImage = () => {
    let bgImg = DEFAULT_BG_IMAGE;

    if (surveyResponsesForBgImage.data) {
      const responses = surveyResponsesForBgImage.data.surveyResponses;
      if (responses && Array.isArray(responses)) {
        responses.map(response => {
          if (response.key === 'TEAM_BACKGROUND' && !(response.responseValue instanceof Object)) {
            bgImg = response.responseValue;
          }
        });
      }
    }

    return (
      <div className="hero has-page-covering" style={{ backgroundImage: `url('${bgImg}')` }}>
        <div className="has-text-right" data-container="background-image">
          {renderEditButton({
            text: 'Edit Photo',
            action: () => {
              setEditBackgroundPhotoModalIsOpen(true);
              setSelectedBackgroundImage(bgImg);
            },
          })}
        </div>
      </div>
    );
  }; */

  const renderHeroImage = () => {
    let bgImg;
    //const image = luminateProperties.teamPage.backgroundImage;
    //let bgImg = image && image !== 'User Provided No Response' ? luminateProperties.teamPage.backgroundImage : DEFAULT_BG_IMAGE;

    const checkFrID = (city) => {
      if (city.includes(luminateProperties.frId)){
        // console.log("yes found it");
        return luminateProperties.frId
      }
    }

    if(surveyResponses.data){
      if(surveyResponses.data.teamBackground === 'User Provided No Response' || surveyResponses.data.teamBackground === '' || surveyResponses.data.teamBackground === '[object Object]'){
        switch(luminateProperties.frId){
          // case CHICAGO.replace(/\D/g,''):
          //   DEFAULT_BG_IMAGE = '../p2p-ui-framework/dist/img/programs/heroes/backgrounds/chicago/background-1.jpg';
          //   break;
          // case NEWYORK.replace(/\D/g,''):
          //   DEFAULT_BG_IMAGE = '../p2p-ui-framework/dist/img/programs/heroes/backgrounds/new-york/background-1.jpg';
          //   break;
          // case LONDON.replace(/\D/g,''):
          //   DEFAULT_BG_IMAGE = '../p2p-ui-framework/dist/img/programs/heroes/backgrounds/london/background-1.jpg';
          //   break;
          // default:
          //   DEFAULT_BG_IMAGE = '../p2p-ui-framework/dist/img/programs/heroes/backgrounds/default/background-1.jpg';
          // case CHICAGO.replace(/\D/g,''):
          case checkFrID(CHICAGO):
            DEFAULT_BG_IMAGE = '../p2p-ui-framework/dist/img/programs/heroes/backgrounds/chicago/background-1.jpg';
            break;
          // case NEWYORK.replace(/\D/g,''):
          case checkFrID(NEWYORK):
            DEFAULT_BG_IMAGE = '../p2p-ui-framework/dist/img/programs/heroes/backgrounds/new-york/background-1.jpg';
            break;
          // case LONDON.replace(/\D/g,''):
          case checkFrID(LONDON):
            DEFAULT_BG_IMAGE = '../p2p-ui-framework/dist/img/programs/heroes/backgrounds/london/background-1.jpg';
            break;
          // case checkFrID(BOSTON):
          //   DEFAULT_BG_IMAGE = '../p2p-ui-framework/dist/img/programs/heroes/backgrounds/boston/background-1.jpg';
          //   break;
          default:
            DEFAULT_BG_IMAGE = '../p2p-ui-framework/dist/img/programs/heroes/backgrounds/default/background-1.jpg';
        }
        bgImg = DEFAULT_BG_IMAGE;
      }
      else{
        bgImg = surveyResponses.data.teamBackground;
      }
    }

    luminateProperties.teamPage.backgroundImage = bgImg;

    return (
      <div className="hero has-page-covering" style={{ backgroundImage: `url('${bgImg}')` }}>
        <div className="has-text-right" data-container="background-image">
          {renderEditButton({
            text: 'Edit Photo',
            action: () => {
              setEditBackgroundPhotoModalIsOpen(true);
              setSelectedBackgroundImage(bgImg);
            },
          })}
        </div>
      </div>
    );
  };

  const renderProgressBar = () => (
    <ProgressBar
      goal={teamInfo.data.goal}
      progress={teamInfo.data.amountRaised}
      showIndicator={true}
      goalText="Our goal:"
      raisedText="Amount Raised:"
      editButton={renderEditButton({ text: 'Edit Goal', action: () => setEditGoalModalIsOpen(true), className: 'edit-goal' })}
    />
  );

  const renderTopParticipants = () => {
    if (teamMemberPhotos.data) {
      return <TopHeroesList items={teamMemberPhotos.data} showLink={true} eventId={EVENT_ID} />;
    }
  };

  const renderTitle = () => {
    //luminate only returns a max of 25 (default) so this number will only be accurate up to 25. Need to use the numMembers supplied in useTeamInfo
    //const participantCount = teamRoster.data.length;
    const participantCount = teamInfo.data.numMembers;

    /* const renderGroupLeaderLink = () =>
      `<a href="TR?pg=personal&fr_id=${EVENT_ID}&px=${teamInfo.data.captainConsId}" aria-label="Vist group leader ${teamInfo.data.captainFirstName} ${teamInfo.data.captainLastName}'s fundraising page">${teamInfo.data.captainFirstName} ${teamInfo.data.captainLastName}</a>`; */

    return (
      <PageTitle
        title={teamInfo.data.name}
        //firstSubtitle={`${participantCount} Member${participantCount === 1 ? '' : 's'}`}
        //secondSubtitle={`Team Captain: ${renderGroupLeaderLink()}`}
      />
    );
  };

  const renderEventNameLink = () => {
    return (
      <div className="event-link">
        <a href={EVENT_LINK}>{EVENT_NAME}</a><br />
        Team Captain: <a href={TEAM_CAPTAIN_LINK}>{teamInfo.data.captainFirstName} {teamInfo.data.captainLastName}</a>
      </div>
    );
  };

  //should really make this call before the page tries to render. Leaving as is for now but should be revisited so the 'loading' does not show
  const renderTeamTotalActivity = (EVENT_ID, TEAM_ID) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState({});
  
    useEffect(() => {
      fetch(`https://${BOUNDLESS_MOTION_PREFIX}.boundlessfundraising.com/mobiles/${BOUNDLESS_MOTION_DB}/getMotionActivitySummary?activity_scope=team&event_id=${EVENT_ID}&team_id=${TEAM_ID}`, {
        method: 'GET',
        headers: headers,
      })
        .then(res => res.json())
        .then(
          (result) => {
            setIsLoaded(true);
            setItems(result);
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )
    }, [])
  
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>Loading...</div>;
    } else if(items.total > 0) {
      return (
        <div className="teams-miles-icon">
          <div className="teams-icon">
            <svg id="a" xmlns="http://www.w3.org/2000/svg" width="38" height="38"><path d="M23.75,19c-1.31,0-2.38,1.06-2.38,2.38s1.06,2.38,2.38,2.38h7.12c3.93,0,7.12,3.12,7.12,7.12s-3.19,7.12-7.12,7.12H10.36c.65-.73,1.43-1.68,2.23-2.73,.47-.62,.95-1.31,1.41-2.02H30.88c1.31,0,2.38-1.06,2.38-2.38s-1.06-2.38-2.38-2.38h-7.12c-4,0-7.19-3.19-7.19-7.12s3.19-7.12,7.19-7.12h3.12c-1.63-2.26-3.12-4.94-3.12-7.12,0-3.94,3.12-7.12,7.12-7.12s7.12,3.19,7.12,7.12c0,4.75-7.12,11.88-7.12,11.88h-7.12Zm7.12-9.5c1.31,0,2.38-1.06,2.38-2.38s-1.06-2.38-2.38-2.38-2.38,1.06-2.38,2.38,1.06,2.38,2.38,2.38ZM8.78,36.2l-.04,.04c-.32,.37-.61,.69-.85,.95-.03,.03-.06,.06-.08,.09-.42,.45-.68,.71-.68,.71,0,0-7.12-7.12-7.12-11.88,0-4,3.19-7.19,7.12-7.19s7.12,3.19,7.12,7.19c0,2.18-1.5,4.86-3.12,7.12-.88,1.13-1.65,2.14-2.35,2.95h0Zm-1.72-7.7c1.38,0,2.38-1.06,2.38-2.38s-.99-2.38-2.38-2.38c-1.24,0-2.38,1.06-2.38,2.38s1.13,2.38,2.38,2.38Z" fill="#008ccf"/></svg>
          </div>
          <div>
            <span className="team-members-number"><strong>{items.total}</strong></span><br />Total Miles
          </div>
        </div>
      );
    }
  }

  const renderActivityLink = () => {
      return (
        <div className="teams-walking-icon">
          <div className="teams-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="21.84" height="34.94"><path d="M17.47,3.28c0,1.81-1.47,3.28-3.28,3.28s-3.28-1.47-3.28-3.28,1.47-3.28,3.28-3.28,3.28,1.47,3.28,3.28ZM8.63,13.6c-.06,.03-.13,.05-.19,.08l-.75,.33c-1.04,.46-1.86,1.31-2.29,2.37l-.1,.26c-.45,1.12-1.72,1.67-2.84,1.21-1.12-.45-1.66-1.72-1.22-2.84l.1-.26c.85-2.11,2.48-3.81,4.56-4.74l.75-.33c1.42-.63,2.9-.96,4.51-.96,3.04,0,5.79,1.83,6.96,4.63l.99,2.51,1.52,.73c1.08,.54,1.52,1.85,.98,2.93-.54,1.08-1.85,1.52-2.93,.98l-1.82-.91c-.7-.35-1.26-.95-1.56-1.67l-.66-1.57-1.32,4.47,3.38,3.69c.37,.4,.63,.89,.76,1.42l1.57,6.28c.29,1.17-.42,2.36-1.58,2.65-1.17,.29-2.36-.42-2.71-1.58l-1.45-6.02-4.82-5.26c-1.01-1.1-1.45-2.63-1-4.07l1.15-4.33Zm-3.94,13.56l1.7-4.26c.15,.2,.31,.4,.48,.59l2.78,3.03-.99,2.47c-.16,.42-.41,.79-.72,1.1l-4.21,4.21c-.85,.85-2.24,.85-3.09,0-.85-.85-.85-2.23,0-3.09l4.05-4.05Z" fill="#008ccf"/></svg>
          </div>
          <div>
            <span className="team-members-number"><strong>{teamMemberPhotos.data.length}</strong></span><br />Participants
          </div>
        </div>
      );
  };

  const fundraisingLeaderboardRef = React.createRef();

  const scrollToAnchorLink = ref => {
    const el = ref.current ? ref.current : ref;

    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  const renderDonationButtons = () => (
    <div className="donate-buttons">
      <a href={`${joinTeamUrl}`} target="_blank" rel="noreferrer" className="button is-primary">
        Join this Team
      </a>
      <button onClick={() => scrollToAnchorLink(fundraisingLeaderboardRef)} className="button is-donate">
        Donate to a Team Member
      </button>
    </div>
  );

  const renderProfileImage = () => <ProfileImage src={teamPhoto.data.customUrl} />;

  const renderSocialShare = () => <SocialShare title={'Share'} description={'Help support the kids of St. Jude'} image={'../images/events/socialevents.jpg'} />;

  const renderSupportTeamModal = () => {
    if (teamRoster.data.length > 0) {
      const items = teamRoster.data
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(item => ({
          linkText: item.name,
          linkHref: item.donationLink,
        }));
      return <LinkListModal isOpen={supportTeamModalIsOpen} onClose={closeModals} title="Support a Project" items={items} />;
    }
    return null;
  };

  const renderChangeGoalModal = () => (
    <EditGoalModal
      isOpen={editGoalModalIsOpen}
      onClose={closeModals}
      goal={convertCentsToDollars(teamInfo.data.goal)}
      handleSubmit={handleUpdateGoal}
      errorMessage={errorMessage}
    />
  );

  const renderChangeTitleModal = () => (
    <EditTitleModal
      isOpen={editTitleModalIsOpen}
      onClose={closeModals}
      title={teamInfo.data.name}
      handleSubmit={handleUpdateTitle}
      errorMessage={errorMessage}
    />
  );

  const renderChangePhotoModal = () => (
    <EditImageModal
      isOpen={editPhotoModalIsOpen}
      onClose={closeModals}
      image={teamPhoto.data.customUrl}
      isLoading={isLoading}
      handleSubmit={handleUpdatePhoto}
      errorMessage={errorMessage}
    />
  );

  const renderChangeBackgroundPhotoModal = () => {
    if (bgImageData.data && bgImageData.data.images) {
      let imgData;
      switch(EVENT_ID){
        case checkFrID(CHICAGO):
          imgData = bgImageData.data.images.chicago;
          break;
        case checkFrID(NEWYORK):
          imgData = bgImageData.data.images.newyork;
          break;
        case checkFrID(LONDON):
          imgData = bgImageData.data.images.london;
          break;
        default:
          imgData = bgImageData.data.images.default;
      }
      if (imgData.length > 0) {
        return (
          <EditBackgroundImageModal
            isOpen={editBackgroundPhotoModalIsOpen}
            onClose={closeModals}
            image={selectedBackgroundImage}
            isLoading={isLoading}
            handleSubmit={handleUpdateBackgroundPhoto}
            errorMessage={errorMessage}
            bgImageData={imgData}
          />
        );
      }
    }
  };

  const renderChangeRichTextModal = () => (
    <EditRichTextModal
      isOpen={editRichTextModalIsOpen}
      onClose={closeModals}
      richText={teamPageInfo.data.richText}
      handleSubmit={handleUpdateRichText}
      errorMessage={errorMessage}
    />
  );

  const renderEditButton = ({ text, action, className }) => {
    if (teamInfo.data.captainConsId === parseInt(luminateProperties.user.consId)) {
      return (
        <div className={`edit-container ${className ? className : ''}`} data-container="edit-container">
          <button className="button is-link is-small is-narrow" onClick={action}>
            <span className="icon is-small">
              <i className="svg-icon edit-icon is-white"></i>
            </span>
            <span>{text}</span>
          </button>
        </div>
      );
    } else {
      return null;
    }
  };

  const renderMobileSocialShareButton = ({ action }) => <button onClick={action}>Share</button>;

  const renderMobileSocialShareModal = () => (
    <MobileSocialShareModal isOpen={mobileSocialShareModalIsOpen} onClose={closeModals} socialShare={renderSocialShare()} />
  );

  const renderEventDetails = () => {
    if(eventInfo.data){
      const eventDate = luminateExtend.utils.simpleDateFormat(eventInfo.data[0].event_date, 'EEEE, MMMM d, yyyy');
      let eventLocation;
      switch(luminateProperties.frId){
        case checkFrID(CHICAGO):
          eventLocation = `${eventInfo.data[0].location_name}<br/>${eventInfo.data[0].city}, ${eventInfo.data[0].state} ${eventInfo.data[0].zip}`
          break;
        case checkFrID(NEWYORK):
          eventLocation = `${eventInfo.data[0].location_name}<br/>${eventInfo.data[0].city}, ${eventInfo.data[0].zip}`
          break;
        case checkFrID(LONDON):
          eventLocation = `${eventInfo.data[0].city}<br/>${eventInfo.data[0].country}`
          break;
        case checkFrID(BERLIN):
          eventLocation = `${eventInfo.data[0].city}<br/>${eventInfo.data[0].country}`
          break;
        default:
          eventLocation = `${eventInfo.data[0].location_name}<br/>${eventInfo.data[0].city}, ${eventInfo.data[0].state} ${eventInfo.data[0].zip}`
      }
      return (
        <div data-container="event-details">
          <h3 className="has-text-white">
            Event Details
          </h3>
          <div className="team-event-detail-container">
            <div className="teams-date-icon">
              <div className="teams-icon">
                <svg id="a" xmlns="http://www.w3.org/2000/svg" width="18.73" height="21.41"><path d="M6.69,1.34v1.34h5.35V1.34c0-.74,.6-1.34,1.34-1.34s1.34,.6,1.34,1.34v1.34h2.01c1.11,0,2.01,.9,2.01,2.01v2.01H0v-2.01c0-1.11,.9-2.01,2.01-2.01h2.01V1.34c0-.74,.6-1.34,1.34-1.34s1.34,.6,1.34,1.34ZM0,8.03H18.73v11.37c0,1.11-.9,2.01-2.01,2.01H2.01c-1.11,0-2.01-.9-2.01-2.01V8.03Zm2.68,4.68c0,.37,.3,.67,.67,.67h1.34c.37,0,.67-.3,.67-.67v-1.34c0-.37-.3-.67-.67-.67h-1.34c-.37,0-.67,.3-.67,.67v1.34Zm5.35,0c0,.37,.3,.67,.67,.67h1.34c.37,0,.67-.3,.67-.67v-1.34c0-.37-.3-.67-.67-.67h-1.34c-.37,0-.67,.3-.67,.67v1.34Zm6.02-2.01c-.37,0-.67,.3-.67,.67v1.34c0,.37,.3,.67,.67,.67h1.34c.37,0,.67-.3,.67-.67v-1.34c0-.37-.3-.67-.67-.67h-1.34ZM2.68,18.06c0,.37,.3,.67,.67,.67h1.34c.37,0,.67-.3,.67-.67v-1.34c0-.37-.3-.67-.67-.67h-1.34c-.37,0-.67,.3-.67,.67v1.34Zm6.02-2.01c-.37,0-.67,.3-.67,.67v1.34c0,.37,.3,.67,.67,.67h1.34c.37,0,.67-.3,.67-.67v-1.34c0-.37-.3-.67-.67-.67h-1.34Zm4.68,2.01c0,.37,.3,.67,.67,.67h1.34c.37,0,.67-.3,.67-.67v-1.34c0-.37-.3-.67-.67-.67h-1.34c-.37,0-.67,.3-.67,.67v1.34Z" fill="#ffc32c"/></svg>
              </div>
              <div>
                {eventDate}
              </div>
            </div>
          </div>
          <div className="team-event-detail-container">
            <div className="teams-location-icon">
              <div className="teams-icon">
                <svg id="a" xmlns="http://www.w3.org/2000/svg" width="15.73" height="20.92"><path d="M6.89,20.45C4.76,17.82,0,11.45,0,7.86,0,3.52,3.52,0,7.86,0s7.86,3.52,7.86,7.86c0,3.58-4.79,9.95-6.89,12.58-.5,.63-1.44,.63-1.94,0h0Zm.97-9.96c1.45,0,2.62-1.18,2.62-2.62s-1.18-2.62-2.62-2.62-2.62,1.18-2.62,2.62,1.18,2.62,2.62,2.62Z" fill="#ffc32c"/></svg>
              </div>
              <div>
                {ReactHtmlParser(eventLocation)}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  const renderTopDonors = () => {
    const items = [];
    const trDonorList = document.querySelector('.vscroll-container div');

    if (trDonorList) {
      Object.keys(trDonorList.children).forEach(listRow => {
        const html = trDonorList.children[listRow].innerHTML;
        if (html) {
          const htmlSplit = html.split('</div>');
          if (htmlSplit.length > 1) {
            let donorName = htmlSplit[0].replace('<div class="team-honor-list-name">', '').trim();
            donorName = donorName.replace('&amp;', `&`);
            const amount = htmlSplit[1].replace('<div class="team-honor-list-value">', '').trim();

            items.push({
              title: `${donorName}`,
              subtitle: amount,
            });
          }
        }
      });

      if (items.length > 0) {
        return <TopList {...{ items }} />;
      } else {
        return <p className="has-text-white">No donations yet.</p>;
      }
    }
  };

  const renderSidebar = () => (
    <div>
      <div className="dark-gradient-bg">
        {renderEventDetails()}
        {/* <hr />
        <div data-tab-content="donors">
          <h3 className="has-text-white">Donors</h3>
          <div data-container="donors">{renderTopDonors()}</div>
        </div> */}
      </div>
    </div>
  );

  const renderChangeEventModal = () => {
    if (surveyResponsesForEventDetailsUpdate.data && surveyResponsesForEventDetailsUpdate.data.surveyResponses && IS_TEAM_CAPTAIN) {
      const eventDetailsResponses = [];
      surveyResponsesForEventDetailsUpdate.data.surveyResponses.forEach((response, i) => {
        if (i < 11) {
          eventDetailsResponses.push({
            key: response.key,
            value: typeof response.responseValue !== 'object' ? response.responseValue : '',
            questionText: response.questionText,
            type: response.questionType,
          });
        }
      });

      return (
        <EditEventDetailsModal
          isOpen={editEventModalIsOpen}
          onClose={closeModals}
          surveyData={eventDetailsResponses}
          handleSubmit={handleUpdateEventDetails}
          isLoading={isLoading}
          errorMessage={errorMessage}
        />
      );
    }
  };

  const handleUpdateGoal = async values => {
    const response = await updateTeam({ eventId: EVENT_ID, teamGoal: values.goal * 100 });
    if (response.success) {
      teamInfo.reload();
      setEditGoalModalIsOpen(false);
    } else {
      setErrorMessage(response.message);
    }
  };

  const handleUpdatePhoto = async blob => {
    setIsLoading(true);
    const response = await updateTeamPhoto({ eventId: EVENT_ID, photo: blob });
    setIsLoading(false);
    if (response.success) {
      teamPhoto.reload();
      setEditPhotoModalIsOpen(false);
    } else {
      setErrorMessage(response.message);
    }
  };

  /* const handleUpdateBackgroundPhoto = async bgImage => {
    setIsLoading(true);
    const responses = [
      {
        type: 'string',
        key: 'question_key_TEAM_BACKGROUND',
        value: bgImage,
      },
    ];
    const response = await updateSurveyResponses(EVENT_ID, responses);
    setIsLoading(false);

    if (response[0].success) {
      surveyResponsesForBgImage.reload();
      setEditBackgroundPhotoModalIsOpen(false);
      luminateProperties.teamPage.teamEvent.backgroundImage = bgImage;
    } else {
      setErrorMessage(response[0].message);
    }
  }; */

  const handleUpdateBackgroundPhoto = async bgImage => {
    setIsLoading(true);
    const responses = surveyResponsesForBgImage.data.surveyResponses;
    for (const obj of responses){
      if (obj.key === "TEAM_BACKGROUND"){
        obj.responseValue = bgImage;
        break;
      }
    }
    const response = await updateSurveyResponsesForBackgrounds(EVENT_ID, responses);
    setIsLoading(false);

    if (response[0].success) {
      surveyResponsesForBgImage.reload();
      surveyResponses.reload();
      setEditBackgroundPhotoModalIsOpen(false);
      luminateProperties.teamPage.backgroundImage = bgImage;
    } else {
      setErrorMessage(response[0].message);
    }
  };

  const handleUpdateRichText = async values => {
    const response = await updateTeamPage({ eventId: EVENT_ID, richText: values.richText });
    if (response.success) {
      teamPageInfo.reload();
      setEditRichTextModalIsOpen(false);
    } else {
      setErrorMessage(response.message);
    }
  };

  const handleUpdateTitle = async values => {
    const response = await updateTeam({ eventId: EVENT_ID, teamName: values.title });
    if (response.success) {
      teamInfo.reload();
      setEditTitleModalIsOpen(false);
    } else {
      setErrorMessage(response.message);
    }
  };

  const handleUpdateEventDetails = async (values, surveyData) => {
    setIsLoading(true);
    const responses = [];
    surveyData.map(data => {
      Object.keys(values).map(value => {
        if (data.key === value) {
          responses.push({
            key: `question_key_${data.key}`,
            type: data.type,
            value: values[value],
          });
        }
      });
    });
    const response = await updateSurveyResponses(EVENT_ID, responses);
    setIsLoading(false);

    if (response[0].success) {
      await surveyResponses.reload();
      setEditEventModalIsOpen(false);
    } else {
      setErrorMessage(response[0].message);
    }
  };

  return (
    <div className="heroes-team">
      {renderChangeGoalModal()}
      {renderChangeTitleModal()}
      {renderChangePhotoModal()}
      {renderChangeBackgroundPhotoModal()}
      {renderChangeRichTextModal()}
      {renderSupportTeamModal()}
      {renderMobileSocialShareModal()}
      {renderChangeEventModal()}

      {renderHeroImage()}
      <section className="section">
        <div className="container">
          <div className="columns">
            {/* left column */}
            <div className="column is-one-quarter-desktop sidebar-section is-hidden-mobile is-hidden-tablet-only">
              <div className="has-text-right" data-container="profile-image">
                {renderEditButton({
                  text: 'Edit Photo',
                  action: () => setEditPhotoModalIsOpen(true),
                  className: 'edit-container',
                })}
                {renderProfileImage()}
              </div>
              {renderSidebar()}
            </div>

            {/* right column */}
            <div className="column is-three-quarter-desktop main-content-section">
              <div className="has-text-right is-hidden-desktop" data-container="profile-image">
                <div className="is-hidden-desktop mobile-social-share-button">
                  {renderMobileSocialShareButton({
                    action: () => setMobileSocialShareModalIsOpen(true),
                  })}
                </div>
                {renderEditButton({
                  text: 'Edit Photo',
                  action: () => setEditPhotoModalIsOpen(true),
                })}
                {renderProfileImage()}
              </div>
              <div className="title-and-progress-container">
                <div data-container="title">
                  <div className="level">
                    <div className="level-left">{renderTitle()}{renderEventNameLink()}</div>
                    <div className="level-right is-hidden-mobile is-hidden-tablet-only">
                      <div data-container="social-share" className="columns is-vcentered">
                        <p className="has-text-weight-bold column is-narrow">Share:</p>
                        {renderSocialShare()}
                      </div>
                    </div>
                  </div>
                  <div className="team-number-activity-container">
                    {renderActivityLink()}
                    {renderTeamTotalActivity(EVENT_ID, TEAM_ID)}
                  </div>
                </div>
                <div data-container="progress">{renderProgressBar()}</div>
                {renderDonationButtons()}
              </div>
              {teamRoster.data.length > 0 && (
                <section className="section global-leaderboards fundraising-leaderboard-section pt-3 pb-3" data-container="donors">
                  <div className="container leaderboard-wrap">
                    <div className="tab-content-wrap">
                      <div className="columns">
                        <section className="column is-full tab-content is-active">
                          <div className="columns mb-0">
                            <div className="column is-full">
                              <h3>Team Roster</h3>
                            </div>
                          </div>
                          <div className="columns mb-0">
                            <div className="column is-full pb-o">
                              <SearchParticipant
                                eventId={EVENT_ID}
                                label={'Find a Team Member'}
                                teamName={teamInfo.data.name}
                                eventType={EVENT_TYPE_SEARCH}
                              />
                            </div>
                          </div>
                          <div className="columns">
                            <div className="column is-full py-0">
                              <p className="fundraising-leaderboard-counter">
                                {teamMemberPhotos.data.length > 4
                                  ? `Viewing 1-5 of ${teamMemberPhotos.data.length}`
                                  : `Viewing ${teamMemberPhotos.data.length} of ${teamMemberPhotos.data.length}`}
                              </p>
                            </div>
                          </div>
                          <div className="columns mb-0 is-hidden-mobile">
                            <div className="column">
                              <p className="has-text-weight-bold mb-0">Participant Name</p>
                            </div>
                            <div className="column">
                              <div className="columns mb-0 is-flex">
                                <div className="column">
                                  <p className="has-text-weight-bold has-text-right mb-0">Amount Raised</p>
                                </div>
                              </div>
                            </div>
                            <div className="column">
                              <div className="columns mb-0 is-flex">
                                <div className="column">
                                  <p className="has-text-weight-bold has-text-right mb-0">Miles</p>
                                </div>
                                <div className="column"></div>
                              </div>
                            </div>
                          </div>
                          <div className="columns" ref={fundraisingLeaderboardRef}>
                            <div className="column is-full">{teamMemberPhotos.data.length > 0 && renderTopParticipants()}</div>
                          </div>
                          <div className="columns">
                            <div className="column has-text-centered">
                              {teamMemberPhotos.data.length > 0 && (
                                <a href={viewAllUrl} className="button is-outline mb-4">
                                  See All Team Members
                                </a>
                              )}
                            </div>
                            {/* <div className="column is-half has-text-centered">
                              <a href={`${teamInfo.data.teamDonateURL}`}>Make a general donation to this team</a>
                            </div> */}
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              <div>
                <div data-container="about">
                  {renderEditButton({ text: 'Edit Story', action: () => setEditRichTextModalIsOpen(true) })}
                  <br /><br />
                  {ReactHtmlParser(teamPageInfo.data.richText)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="dark-gradient-bg is-hidden-desktop">
          {renderEventDetails()}
        </div>
    </div>
  );
};
